@if (isPreviwable()) {
  <div class="camera-sequence-preview">
    <div class="camera-sequence-preview__title-container">
      @for (title of titles(); track title; let i = $index) {
        <span
          class="camera-sequence-preview__title"
          [ngStyle]="{ left: (i * 100) / titles().length + '%' }"
        >
          {{ title }}
        </span>
      }
      @for (title of titles(); track title; let i = $index) {
        <span
          class="camera-sequence-preview__dot"
          [ngStyle]="{ left: (i * 100) / titles().length + '%' }"
        ></span>
      }
    </div>
    <div class="camera-sequence-preview__container">
      @for (segment of offsetSegments(); track $index) {
        <span
          class="camera-sequence-preview__offset"
          [ngStyle]="{
            left: getPercent(segment.left) + '%',
            width: getPercent(segment.width) + '%',
          }"
        ></span>
      }
      @for (fix of fixes(); track fix; let i = $index) {
        <span
          class="camera-sequence-preview__fix"
          [ngStyle]="{ left: getPercent(fix) + '%' }"
          [matTooltip]="getGeneralString(fix)"
        ></span>
      }
      @if (mode() && trigger() && trigger() !== 'TIMER') {
        <div class="camera-sequence-preview__no-time">
          {{ mode() }}s triggered by {{ trigger() }}
        </div>
      }
      @if (!trigger()) {
        <div class="camera-sequence-preview__no-time">NO TRIGGER SELECTED</div>
      }
    </div>
  </div>
} @else {
  <div class="camera-sequence-preview">
    <div class="camera-sequence-preview__empty">NO PREVIEW AVAILABLE FOR SELECTED FIELDS</div>
  </div>
}
